// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore"
import { getStorage } from "firebase/storage"
import { getAuth } from "firebase/auth"
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCBfEBpUKepLxWITPna7_1zVeDhWyvPFOI",
  authDomain: "coral-circlet-331006.firebaseapp.com",
  projectId: "coral-circlet-331006",
  storageBucket: "coral-circlet-331006.appspot.com",
  messagingSenderId: "440322941950",
  appId: "1:440322941950:web:bbb2aa67ec81cd0d8c16af",
  measurementId: "G-8BMVPGGB9Z"
 
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app)
export const storage = getStorage(app)
export const auth = getAuth(app)
